import { ChannelType } from 'app/components/Notification/Constants';
import { missingField } from 'app/constants';
import { RecruiterPlacement } from 'app/models/WorkDesk/RecruiterPlacementDetails';
import { getStatusAge } from 'utils/common/statusAge';
import { GetMomentOfDate } from 'utils/dates/moment';
import { Concatenate } from 'utils/string/string';
import Actions from '../../../../../app/assets/images/WorkDesk/Actions.png';
import Call from '../../../../../app/assets/images/WorkDesk/Call.png';
import email from '../../../../../app/assets/images/WorkDesk/email.png';
import { getMultiSelectOptions, notSent } from 'app/ComponentLibrary/Filter/helper';
import { getMultiSelectDefaultOptions } from '../utils';
import {
  getMultiSelectOptions as getMultiSelectOptionsGlobal,
  revalidateChipSelection,
} from 'app/components/GlobalSearch/helper';
import placementSubmission from 'app/assets/jsons/PlacementSubmissionFilter.json';
import { filterUserChoices, getFilteredData } from '../WorkdeskFilter/filterHelper';
import { call, put, select } from 'redux-saga/effects';
import { selectFilterChipSelected } from 'app/components/Common/Grid/GridStateManagement/GridState.selectors';
import { gridStateActions } from 'app/components/Common/Grid/GridStateManagement/GridState.redux';
import { recruiterPlacementActions } from '../RecruiterPlacements.redux';

export enum recPlacementsGridKeys {
  placementRecruiter = 'placementRecruiter',
  statusAbbr = 'statusAbbr',
  candidate = 'candidate',
  skillSet = 'skillSet',
  discipline = 'discipline',
  specialty = 'specialty',
  endDate = 'endDate',
  startDate = 'startDate',
  availabilityStartDate = 'availabilityStartDate',
  notContactedSinceDate = 'notContactedSinceDate',
  lastApplicationDate = 'lastApplicationDate',
  availableToStartDate = 'availableToStartDate',
  callBackDate = 'callBackDate',
  facilityName = 'facilityName',
  facilityCity = 'facilityCity',
  facilityState = 'facilityState',
  lastCueDate = 'lastCueDate',
  lastCueNote = 'lastCueNote',
  cuedFrom = 'cuedFrom',
  cueNoteAttributes = 'cueNoteAttributes',
  arbitrationStatus = 'arbitrationStatus',
  arbitrationSentDate = 'arbitrationSentDate',
  arbitrationSignedDate = 'arbitrationSignedDate',
  positionsAvailable = 'positionsAvailable',
  filesOut = 'filesOut',
  filesPending = 'filesPending',
  eligibilityCleared = 'eligibilityCleared',
  submissionStatus = 'submissionStatus',
  placementStatusId = 'placementStatusId',
  placementTypeId = 'placementTypeId',
}

export function recruiterPlacementFlattenData(PlacementInfo: RecruiterPlacement[]) {
  const missingFieldValue = missingField;

  const formatDate = (date: any) => (date?.isValid() ? date.format('MM/DD/YYYY') : missingFieldValue);
  const formatCueDate = (date: any) => (date ? date.format('MM/DD/yyyy hh:mm:ss A') : missingFieldValue);
  const concatenateNames = (first: string, last: string) =>
    first || last ? `${first || ''} ${last || ''}`.trim() : missingFieldValue;

  return PlacementInfo.map((info, i) => {
    const availabilityDate = GetMomentOfDate(info.availabilityStartDate);
    const startDate = GetMomentOfDate(info.startDate);
    const endDate = GetMomentOfDate(info.endDate);
    const lastContacted = GetMomentOfDate(info.candidate.lastContactedOnDate);
    const statusChanged = GetMomentOfDate(info.statusChangeDate);
    const cueDate = info?.lastCueNote ? GetMomentOfDate(info?.lastCueNote?.cueDate) : null;

    const statusAgeDetails = getStatusAge(
      info.activityType === 'Offer' ? info.initialOfferDate : info.statusChangeDate,
    );
    return {
      id: `${info.placementId}-${i}`,
      indexCounter: i,
      previewDrawerViewerId: info.candidate.candidateId,
      previewDrawerViewerType: 1,
      placementId: info.placementId,
      candidateId: info.candidate.candidateId,
      brandId: info.brandId || missingFieldValue,
      brand: info.brand,
      [recPlacementsGridKeys.candidate]: concatenateNames(info.candidate.first, info.candidate.last),
      activityType: info.activityType,
      status: info.status || missingFieldValue,
      [recPlacementsGridKeys.statusAbbr]: info.statusAbbr,
      placementStatusId: info.placementStatusId,
      placementTypeId: info.placementTypeId,
      orderId: info.orderId,
      [recPlacementsGridKeys.discipline]: info.skillset?.disciplineAbbr || missingFieldValue,
      [recPlacementsGridKeys.specialty]: info.skillset?.specialtyAbbr || missingFieldValue,
      [recPlacementsGridKeys.skillSet]:
        `${info.skillset?.disciplineAbbr || ''}-${info.skillset?.specialtyAbbr || ''}`.trim() || missingFieldValue,
      [recPlacementsGridKeys.availabilityStartDate]: formatDate(availabilityDate),
      [recPlacementsGridKeys.startDate]: formatDate(startDate),
      [recPlacementsGridKeys.endDate]: formatDate(endDate),
      facilityId: info.facility.facilityId,
      [recPlacementsGridKeys.facilityName]: info.facility.name || missingFieldValue,
      [recPlacementsGridKeys.facilityCity]: info.facility.city || missingFieldValue,
      [recPlacementsGridKeys.facilityState]: info.facility.state || missingFieldValue,
      lastContactedOn: formatDate(lastContacted),
      extensionStatus: info.extensionStatus || missingFieldValue,
      accountManager: concatenateNames(info.accountManager.firstName, info.accountManager.lastName),
      accountManagerAttributes: [
        { key: Call, value: info.accountManager.phoneNumber || missingFieldValue },
        { key: email, value: info.accountManager.email || missingFieldValue },
      ],
      credentialingAnalyst: concatenateNames(info.credentialingAnalyst.firstName, info.credentialingAnalyst.lastName),
      analystAttributes: [
        { key: Call, value: info.credentialingAnalyst.phoneNumber || missingFieldValue },
        { key: email, value: info.credentialingAnalyst.email || missingFieldValue },
      ],
      clinicalManager: concatenateNames(info.clinicalManager.firstName, info.clinicalManager.lastName),
      clinicalManagerAttributes: [
        { key: Call, value: info.clinicalManager.phoneNumber || missingFieldValue },
        { key: email, value: info.clinicalManager.email || missingFieldValue },
      ],
      statusChangedDate: formatDate(statusChanged),
      statusAge: statusAgeDetails?.message || missingFieldValue,
      statusAgeValue: statusAgeDetails?.totalMinutes || Number.MIN_VALUE,
      candidatePhone: info.candidate.phoneNumber || missingFieldValue,
      candidatePhoneAttributes: ChannelType.voice,
      candidateEmail: info.candidate.email || missingFieldValue,
      candidateEmailAttributes: ChannelType.email,
      [recPlacementsGridKeys.notContactedSinceDate]: info.candidate.notContactedSinceDate,
      [recPlacementsGridKeys.callBackDate]: info.candidate.callBackDate,
      [recPlacementsGridKeys.lastApplicationDate]: info.candidate.lastApplicationDate,
      [recPlacementsGridKeys.availableToStartDate]: info.candidate.availableToStartDate,
      actions: Actions,
      [recPlacementsGridKeys.placementRecruiter]: concatenateNames(
        info?.recruiter?.firstName,
        info?.recruiter?.lastName,
      ),
      placementRecruiterId: info?.recruiter?.id,
      lastCueDate: formatCueDate(cueDate),
      lastCueNote: info?.lastCueNote?.cueNote || missingFieldValue,
      cuedFrom: info?.lastCueNote
        ? `${info?.lastCueNote?.cuedFromFirstName} ${info?.lastCueNote?.cuedFromLastName}`
        : missingFieldValue,
      cuedTo: info?.lastCueNote?.cuedToId || missingFieldValue,
      cueNoteAttributes: {
        date: info?.lastCueNote?.cueDate,
        cueNote: info?.lastCueNote?.cueNote,
        cuedFrom: info?.lastCueNote
          ? `${info?.lastCueNote?.cuedFromFirstName} ${info?.lastCueNote?.cuedFromLastName}`
          : missingFieldValue,
        cuedTo: info?.lastCueNote?.cuedToId,
      },
      [recPlacementsGridKeys.arbitrationStatus]: info?.arbitrationStatus || missingFieldValue,
      [recPlacementsGridKeys.arbitrationSentDate]: info?.arbitrationSentDate
        ? formatCueDate(GetMomentOfDate(info.arbitrationSentDate))
        : missingFieldValue,
      [recPlacementsGridKeys.arbitrationSignedDate]: info?.arbitrationSignedDate
        ? formatCueDate(GetMomentOfDate(info.arbitrationSignedDate))
        : missingFieldValue,
      positionsAvailable: info.positionsAvailable || missingFieldValue,
      filesOut: info.filesOut || missingFieldValue,
      filesPending: info.filesPending || missingFieldValue,
      eligibilityCleared: info.eligibilityCleared,
      submissionStatus:
        info.submissionError !== undefined ||
        info.submissionAutomated !== undefined ||
        info.submissionSuccessful !== undefined
          ? {
              submissionError: info.submissionError,
              submissionAutomated: info.submissionAutomated,
              submissionSuccessful: info.submissionSuccessful,
              placementStatus: info.status,
              placementStatusId: info.placementStatusId,
              placementTypeId: info.placementTypeId,
            }
          : null,
    };
  });
}

export const isOneRecruiterSelected = (appliedFilterValues: any) => {
  return (
    !appliedFilterValues ||
    (appliedFilterValues['placementRecruiter'] && appliedFilterValues['placementRecruiter']?.length > 0)
  );
};

export function* generateFilterSpecs(filterSpecs, arbitrationAgreement) {
  let arbitrationStatusOpts = [];
  if (arbitrationAgreement) {
    // Get existing options from API (may contain null, "Sent", "Signed", etc.)
    const existingOptions = Array.isArray(filterSpecs?.arbitrationStatusOpts) 
      ? filterSpecs.arbitrationStatusOpts 
      : [];
    // Replace null values with "Not Sent" and filter out duplicates
    const processedOptions = existingOptions
      .map(opt => (opt === null || opt === undefined ? notSent : opt))
      .filter((opt, index, arr) => arr.indexOf(opt) === index); // Remove duplicates
    arbitrationStatusOpts = getMultiSelectDefaultOptions(processedOptions, true);
  }

  const submissionOpts = filterSpecs.submissionOpts
    ? getMultiSelectOptionsGlobal(filterSpecs.submissionOpts, { withoutAllOption: true })
    : getMultiSelectOptionsGlobal(placementSubmission || [], { withoutAllOption: true });

  return {
    candidateNameOpts: filterSpecs.candidateNameOpts ? getMultiSelectOptions(filterSpecs.candidateNameOpts) : [],
    disciplineOpts: filterSpecs.disciplineOpts ? getMultiSelectOptions(filterSpecs.disciplineOpts) : [],
    specialtyOpts: filterSpecs.specialtyOpts ? getMultiSelectOptions(filterSpecs.specialtyOpts) : [],
    facilityNameOpts: filterSpecs.facilityNameOpts ? getMultiSelectOptions(filterSpecs.facilityNameOpts) : [],
    cityOpts: filterSpecs.cityOpts ? getMultiSelectOptions(filterSpecs.cityOpts) : [],
    stateOpts: filterSpecs.stateOpts ? getMultiSelectOptions(filterSpecs.stateOpts) : [],
    arbitrationStatusOpts,
    submissionOpts,
  };
}

export function* handleFilterLogic(filter, filterSpecs, flattenedData) {
  const updatedFilter = yield call(filterUserChoices, filterSpecs, filter.values, filter.setValue);
  const selectedChips = yield select(selectFilterChipSelected);

  const newSelectedChips = yield call(revalidateChipSelection, updatedFilter, selectedChips);

  const filteredData = yield call(getFilteredData, updatedFilter, flattenedData, newSelectedChips);

  const filterAttributes = {
    filterObject: Object.entries(updatedFilter),
    selectedChipFilters: newSelectedChips,
  };

  yield put(gridStateActions.setFilterAttributes(filterAttributes));
  yield put(recruiterPlacementActions.setFilteredData(filteredData));
}

export function hasUIFilter(values: Record<string, any>): boolean {
  for (const key in values) {
    if (key === 'placementRecruiter') continue;

    const value = values[key];

    if (Array.isArray(value) && value.length > 0) {
      return true;
    }

    if (value !== null && typeof value === 'object' && Object.keys(value).length > 0) {
      return true;
    }

    if (typeof value === 'string' && value.trim() !== '') {
      return true;
    }

    if (value !== null && value !== undefined) {
      return true;
    }
  }

  return false;
}
